import React from 'react'
import 'url-search-params-polyfill'
import moment from 'moment'
import { Loader, Dimmer } from 'semantic-ui-react'

import { WithLocationsReport } from '../../connectors/reports'

@WithLocationsReport
export default class LocationsReportTable extends React.PureComponent {
  renderTableHeader() {
    return (
      <thead>
        <tr>
          <th>
            <span>Period</span>
          </th>
          <th>
            <span>Route</span>
          </th>
          <th>
            <span>Name</span>
          </th>
          <th>
            <span>Address</span>
          </th>
          <th>
            <span>Permit Number</span>
          </th>
          <th>
            <span>City</span>
          </th>
          <th>
            <span>Issued</span>
          </th>
          <th>
            <span>Expires</span>
          </th>
          <th>
            <span>Signed By</span>
          </th>
          <th>
            <span>Phone</span>
          </th>
          <th>
            <span>Email</span>
          </th>
          <th>
            <span>Address</span>
          </th>
        </tr>
      </thead>
    )
  }

  renderTableRow(location) {
    const {
      start = moment()
        .endOf('month')
        .subtract(2, 'months')
        .startOf('month'),
      end = moment().endOf('month'),
    } = this.props

    let periodColumn = `${moment(start).format('MM/DD/YY')} - ${moment(
      end
    ).format('MM/DD/YY')}`

    const permit = location.permit || {}

    const row = (
      <tr key={`${location.id}-${location.isTotalRow ? 'total' : ''}`}>
        <td>
          <span>{periodColumn}</span>
        </td>
        <td>
          <span>{location.route.name}</span>
        </td>
        <td>
          <span>{location.name}</span>
        </td>
        <td>
          <span>{location.address}</span>
        </td>
        <td>
          <span>{permit.permit_number}</span>
        </td>
        <td>
          <span>{permit.city}</span>
        </td>
        <td>
          <span>
            {permit.issued_date
              ? moment(permit.issued_date).format('MM/DD/YY')
              : ''}
          </span>
        </td>
        <td>
          <span>
            {permit.expiration_date
              ? moment(permit.expiration_date).format('MM/DD/YY')
              : ''}
          </span>
        </td>
        <td>
          <span>{permit.signed_by}</span>
        </td>
        <td>
          <span>{permit.phone}</span>
        </td>
        <td>
          <span>{permit.email}</span>
        </td>
        <td>
          <span>{permit.address}</span>
        </td>
      </tr>
    )

    return row
  }

  render() {
    const { locationsReport, loading } = this.props

    return (
      <div>
        <table
          className="ui sortable table"
          style={{
            display: 'block',
            'overflow-x': 'auto',
          }}
        >
          {this.renderTableHeader()}
          <tbody>
            {loading ? (
              <Dimmer active>
                <Loader />
              </Dimmer>
            ) : locationsReport && locationsReport.length ? (
              <React.Fragment>
                {locationsReport.map((location, i) => {
                  const rowElement = this.renderTableRow(location)
                  return <React.Fragment>{rowElement}</React.Fragment>
                })}
              </React.Fragment>
            ) : (
              'No data.'
            )}
          </tbody>
        </table>
      </div>
    )
  }
}
